import React, { useState, useEffect } from 'react';
import { useTheme } from 'native-base';
import { Center, Divider, FlatList, VStack, Text, Box } from 'native-base';
import PrivateMessage from './PrivateMessage';
import GoBackButton from '../content/common/GoBackButton';
import CommunicationPreferencesButton from '../content/common/reusables/CommunicationPreferencesButton';
import CreateMessageBox from './CreateMessageBox';
import Banner from '../content/common/reusables/Banner';
import { sentenceJoinUserNames, toggleUserDMOption } from '../utils/helpers';
import { useEnvState } from '../../context/env';
import { useAuthState, useAuthDispatch, authUtil } from '../../context/auth';
import { useOverviewDispatch, useOverviewState } from '../../context/overview';
import { useMessagesState, useMessagesDispatch } from '../../context/messages';
import { useMessageBusState } from '../../context/messagebus';
import { useMessageBus } from '../hooks/useMessageBus';
import { topicsAPI } from '../../context/topics';
import SearchRecipient from './SearchRecipient';
import { LANGUAGES } from '../Constants';

/* TODO: Similar logic to SingleTopicScreen/Replies... could maybe do some consolidation...?
 *    I don't think either one is clever in grabbing from the message bus and adding a new reply to the post_stream
 */
// TODO: Add capability to grab older messages from this topic, akin to Replies. Currently just doing lazy case of loading most recent 20 messages
const PrivateMessageScreen = props => {
  var _props$route;
  const theme = useTheme(),
    {
      colors
    } = theme;
  const [privateMessages, setPrivateMessages] = useState(null);
  const [topic, setTopic] = useState(null);
  const [updateTopic, setUpdateTopic] = useState(false);
  const [privateMessageId, setPrivateMessageId] = useState((_props$route = props.route) === null || _props$route === void 0 || (_props$route = _props$route.params) === null || _props$route === void 0 ? void 0 : _props$route.topicId);
  const envState = useEnvState();
  const authState = useAuthState();
  const authDispatch = useAuthDispatch();
  const messagesState = useMessagesState();
  const messagesDispatch = useMessagesDispatch();
  const messageBusState = useMessageBusState();
  const overviewState = useOverviewState();
  const overviewDispatch = useOverviewDispatch();
  const [dmUsers, setDMUsers] = useState(messagesState.message_users);
  const [topicTitle, setTopicTitle] = useState('');
  const [repliesStream, setRepliesStream] = useState([]);
  const [topicIdListForReplies, setTopicIdListForReplies] = useState([]);

  // this is shared with the ForumHomeScreen, so we should already be initialized!
  const {
    isInitialized,
    isListening,
    getUniqueList,
    refreshTopic,
    closeReplyBanner
  } = useMessageBus({
    userAuthenticated: authUtil.userAuthed(authState)
  });
  useEffect(() => {
    if (props.dispatchForumAuth) {
      toggleUserDMOption({
        authState,
        envState,
        authDispatch
      });
    }
  }, [props.dispatchForumAuth]);
  useEffect(() => {
    setTopicIdListForReplies(getUniqueList(messageBusState.replies));
  }, [messageBusState.replies]);
  const refreshReplyBanner = () => {
    refreshTopic(privateMessageId);
    // lazy case, we have to make an API call again anyway so just call again
    getPrivateMessageTopic();
    // let's set notification to read since we are here
    // overwrite the messages to be read
    overviewDispatch({
      type: 'SET_NOTIFICATIONS',
      payload: {
        message: overviewState.notifications.message.map(item => {
          return {
            ...item,
            read: item.topic_id === privateMessageId ? true : item.read
          };
        })
      }
    });
    overviewDispatch({
      type: 'SET_MESSAGES',
      payload: overviewState.messages
    }); //reset messages with read notification
    overviewDispatch({
      type: 'SET_UNREAD_MESSAGES_COUNT',
      payload: overviewState.unreadMessagesCount - 1
    });
  };
  useEffect(() => {
    getPrivateMessageTopic();
  }, [privateMessageId, updateTopic]);
  useEffect(() => {
    updateTopicTitle();
  }, [dmUsers]);
  const updateTopicTitle = () => {
    setTopicTitle(`Message between ${sentenceJoinUserNames({
      authState,
      users: dmUsers,
      includeSelf: true
    })}`);
  };
  const getPrivateMessageTopic = async () => {
    // Default to getting last 20 messages
    updateTopic && setUpdateTopic(false);
    try {
      let response = {};
      if (privateMessageId) {
        var _response;
        const lastPage = true;
        response = await topicsAPI.getSingleTopic(envState.base_url, authState.api_key, privateMessageId, lastPage);
        const post_stream = (_response = response) === null || _response === void 0 ? void 0 : _response.post_stream;
        if (post_stream) {
          const sortedMessages = post_stream.posts.sort((a, b) => Date(b.created_at) - Date(a.created_at));
          setRepliesStream(post_stream.stream);
          setTopic(response);
          setPrivateMessages(sortedMessages);
        }
      }
      return response;
    } catch (err) {
      console.log('Error while getting private messages', err);
      return {};
    }
  };
  const resetPrivateMessageScreen = () => {
    messagesDispatch({
      type: 'RESET_MESSAGE_USERS'
    });
    setPrivateMessageId(null);
  };
  const renderItem = ({
    item: pmsg
  }) => /*#__PURE__*/React.createElement(PrivateMessage, {
    pmsg: pmsg,
    key: pmsg.id
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GoBackButton, {
    navigation: props.navigation,
    my: 1
  }), /*#__PURE__*/React.createElement(VStack, null, /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(SearchRecipient, {
    navigation: props.navigation,
    setPrivateMessageId: setPrivateMessageId,
    dmUsers: dmUsers,
    setDMUsers: setDMUsers
  })), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginTop: '5px',
      marginBottom: '5px'
    }
  }), messagesState.message_users.length ? /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(Text, {
    paddingBottom: "4",
    alignSelf: "center",
    fontSize: 'xl'
  }, topicTitle)) : null, /*#__PURE__*/React.createElement(Center, {
    w: '100%'
  }, privateMessageId && privateMessages && privateMessages.length > 0 ? /*#__PURE__*/React.createElement(Box, {
    w: "100%"
  }, /*#__PURE__*/React.createElement(FlatList, {
    data: privateMessages,
    renderItem: renderItem,
    keyExtractor: pmsg => pmsg.id.toString()
  })) : /*#__PURE__*/React.createElement(Text, null, "Start a conversation!"), topic && /*#__PURE__*/React.createElement(Banner, {
    type: 'reply',
    refresh: refreshReplyBanner,
    close: closeReplyBanner,
    topicId: topic.id,
    topicIdList: topicIdListForReplies
  })), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginTop: '5px',
      marginBottom: '5px'
    }
  }), authState.dm_option_on ? /*#__PURE__*/React.createElement(CreateMessageBox, {
    topicId: privateMessageId,
    users: dmUsers,
    topicTitle: topicTitle,
    trackForum: props.trackForum,
    setUpdateTopic: setUpdateTopic,
    setPrivateMessageId: setPrivateMessageId
  }) : /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(Text, {
    color: colors.privateMessage.notEnabled
  }, LANGUAGES.DMS_NOT_ENABLED), /*#__PURE__*/React.createElement(CommunicationPreferencesButton, {
    toggleProfileModal: props.toggleProfileModal
  }))));
};
export default PrivateMessageScreen;
//# sourceMappingURL=PrivateMessageScreen.js.map